
<!-- Reusable upload-on-select status indicator (FR1/FR5). Pass the control name as context. -->
<ng-template #uploadStatus let-c>
  <div class="mt-1" *ngIf="uploadState[c]">
    <span *ngIf="uploadState[c] === 'uploading'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Uploading…</span>
    <span *ngIf="uploadState[c] === 'uploaded'" class="text-success small"><i class="fa fa-check-circle"></i> Uploaded</span>
    <span *ngIf="uploadState[c] === 'error'" class="text-danger small"><i class="fa fa-times-circle"></i> {{ uploadError[c] || 'Upload failed — please re-select the file.' }}</span>
  </div>
</ng-template>

<div class="row">

  <form *ngIf="formResetToggle" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>


        <div class="row">
          <div class="col-sm-4">
            <div class="form-check mb-3">
              <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

              <label for="acceptTerms" class="form-check-label">US</label><br />
              <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
              <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
              <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
            </div>
          </div>

        </div>


        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">ICD Info</h3>

            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">


              <div class="row">



                  <div class="col-sm-4">
                      <div class="form-group">

                          <label class="col-form-label  col-md-12" for="login-Distributor_Code">Distributor Number <code>*</code></label>
                          <input type="text" formControlName="Distributor_Code" class="form-control"
                                 [ngClass]="{'is-valid': f.Distributor_Code.valid, 'is-invalid' : submitted && f.Distributor_Code.valid}" placeholder="EnterDistributor_Code"
                                 appAiHint="Distributor Code" [aiHintForm]="icdForm" />
                          <div *ngIf="submitted && f.Distributor_Code.errors" class="invalid-feedback">
                              <div *ngIf="f.Distributor_Code.errors.required">Distributor_Code  is required</div>
                          </div>

                      </div>




                  </div>

                  <div class="col-sm-4">
                      <div class="form-group">
                          <label class="col-form-label  col-md-12" for="login-ICD_Owner_Name">ICD Owner's Name <code>*</code></label>
                          <input type="text" formControlName="ICD_Owner_Name" class="form-control"
                                 [ngClass]="{'is-valid': f.ICD_Owner_Name.valid, 'is-invalid' : submitted && f.ICD_Owner_Name.valid}"
                                 placeholder="Enter  Owner  Name"
                                 appAiHint="ICD Owner Name" [aiHintForm]="icdForm" />
                          <div *ngIf="submitted && f.ICD_Owner_Name.errors" class="invalid-feedback">
                              <div *ngIf="f.ICD_Owner_Name.errors.required">Owner  Name is required</div>
                          </div>

                      </div>
                  </div>

                  <div class="col-sm-4">
                      <div class="form-group">

                          <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">ICD Corporation Name <code>*</code></label>
                          <input type="text" formControlName="Full_Legal_Company_Name" class="form-control"
                                 [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                                 appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                          <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                              <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                          </div>

                      </div>
                  </div>


                  <div class="col-sm-4">

                      <div class="form-group">
                          <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner<code>*</code></label>
                          <div class="col-md-12">
                              <ng-select [searchable]="true" formControlName="Promoting_Owner" (change)="onCheckboxPo($event)">
                                  <ng-option *ngFor="let o of PO_namesData"
                                             [value]="o.ownerName">
                                      {{ o.ownerNameCompany }}
                                  </ng-option>
                              </ng-select>

                              <div *ngIf="submitted && f.Promoting_Owner.errors" class="invalid-feedback">
                                  <div *ngIf="f.Promoting_Owner.errors.required">Promoting Owner is required</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-sm-4">

                      <div class="form-group">
                          <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner's Company<code>*</code></label>
                          <div class="col-md-12">
                              <input type="text" formControlName="Promoting_Owner_Company" class="form-control"
                                     [ngClass]="{'is-valid': f.Promoting_Owner_Company.valid, 'is-invalid' : submitted && f.Promoting_Owner_Company.valid}" placeholder="Enter Promoting Owner Company"
                                     appAiHint="Promoting Owner Company" [aiHintForm]="icdForm" />
                              <div *ngIf="submitted && f.Promoting_Owner_Company.errors" class="invalid-feedback">
                                  <div *ngIf="f.Promoting_Owner_Company.errors.required">Promoting  Company is required</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-sm-4">

                      <div class="form-group">
                          <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant</label>
                          <div class="col-md-12">

                              <ng-select [searchable]="true" formControlName="Regional_Consultant"
                                         (change)="onCheckboxRC($event)">
                                  <ng-option *ngFor="let o of RC_namesData"
                                             [value]="o.ownerName">
                                      {{ o.ownerNameCompany }}
                                  </ng-option>
                              </ng-select>
                              <div *ngIf="submitted && f.Regional_Consultant.errors" class="invalid-feedback">
                                  <div *ngIf="f.Regional_Consultant.errors.required">Regional Consultant is required</div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="col-sm-4">

                      <div class="form-group">
                          <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant's Company</label>
                          <div class="col-md-12">
                              <input type="text" formControlName="Regional_Consultant_Company" class="form-control"
                                     placeholder="Enter Regional Consultant Company"
                                     appAiHint="Regional Consultant Company" [aiHintForm]="icdForm" />
                              <div *ngIf="submitted && f.Regional_Consultant_Company.errors" class="invalid-feedback">
                                  <div *ngIf="f.Regional_Consultant_Company.errors.required">Regional Consultant Company is required</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-sm-4">

                      <div class="form-group">
                          <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant<code>*</code></label>
                          <div class="col-md-12">


                              <ng-select [searchable]="true" formControlName="National_Consultant" [ngClass]="{ 'is-invalid': submitted && f.National_Consultant.errors }"
                                         (change)="onCheckboxNC($event)">
                                  <ng-option *ngFor="let o of NC_namesData"
                                             [value]="o.ownerName">
                                      {{ o.ownerNameCompany }}
                                  </ng-option>
                              </ng-select>

                              <div *ngIf="submitted && f.National_Consultant.errors" class="invalid-feedback">
                                  <div *ngIf="f.National_Consultant.errors.required">National Consultant is required</div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="col-sm-4">

                      <div class="form-group">
                          <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant's Company<code>*</code></label>
                          <div class="col-md-12">
                              <input type="text" formControlName="National_Consultant_Company" class="form-control"
                                     [ngClass]="{'is-valid': f.National_Consultant_Company.valid, 'is-invalid' : submitted && f.National_Consultant_Company.valid}" placeholder="Enter National Consultant Company"
                                     appAiHint="National Consultant Company" [aiHintForm]="icdForm" />
                              <div *ngIf="submitted && f.National_Consultant_Company.errors" class="invalid-feedback">
                                  <div *ngIf="f.National_Consultant_Company.errors.required">National Consultant Company is required</div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="col-sm-4">

                      <div class="form-group">
                          <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name<code>*</code></label>
                          <div class="col-md-12">
                              <input type="text" formControlName="HUB_Manager_Contact_Name" id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name" placeholder="Enter Hub Name" autocomplete="HUB_Manager_Contact_Name"
                                     class="form-control"
                                     appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />

                          </div>
                      </div>
                  </div>










                  <div class="row">


                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="col-form-label  col-md-12" for="login-Owner_Office_Phone">Old Mobile Phone </label>
                              <input type="text" formControlName="Owner_Office_Phone" class="form-control"
                                     placeholder="Enter  Mobile Phone "
                                     appAiHint="Owner Office Phone" [aiHintForm]="icdForm" />
                              <div *ngIf="submitted && f.Owner_Office_Phone.errors" class="invalid-feedback">
                                  <div *ngIf="f.Owner_Office_Phone.errors.required">Mobile Phone   is required</div>
                              </div>

                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="col-form-label  col-md-12" for="login-Owner_Mobile_Phone_N">New Mobile Phone </label>
                              <input type="text" formControlName="Owner_Mobile_Phone_N" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'elevenDigit'" [attr.maxlength]="fieldMaxLengths.Owner_Mobile_Phone_N"
                                     placeholder="X-XXX-XXX-XXXX"
                                     appAiHint="New Owner Mobile Phone" [aiHintForm]="icdForm" />
                              <div class="text-right small mt-1"
                                   [ngClass]="{'text-danger': f.Owner_Mobile_Phone_N.errors?.maxlength,'text-muted': !f.Owner_Mobile_Phone_N.errors?.maxlength}">

                                  {{ icdForm.get('Owner_Mobile_Phone_N')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Mobile_Phone_N }}

                              </div>
                              <div *ngIf="submitted && f.Owner_Mobile_Phone_N.errors" class="invalid-feedback">
                                  <div *ngIf="f.Owner_Mobile_Phone_N.errors.required">Mobile Phone   is required</div>
                                  <div *ngIf="f.Owner_Mobile_Phone_N.errors.maxlength">
                                      Maximum {{ fieldMaxLengths.Owner_Mobile_Phone_N }} characters allowed
                                  </div>
                                  <div>Mobile phone must be 11 digits starting with 1 (country code).</div>
                              </div>

                          </div>
                      </div>

                  </div>

                  <div class="row">
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="col-form-label  col-md-12" for="login-Company_Office_Phone">Old Office Phone </label>
                              <input type="text" formControlName="Company_Office_Phone" class="form-control"
                                     placeholder="Enter  Office Phone"
                                     appAiHint="Company Office Phone" [aiHintForm]="icdForm" />
                              <div *ngIf="submitted && f.Company_Office_Phone.errors" class="invalid-feedback">
                                  <div *ngIf="f.Company_Office_Phone.errors.required">Office Phone  is required</div>
                              </div>

                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="col-form-label  col-md-12" for="login-Company_Office_Phone_N">New Office Phone </label>
                              <input type="text" formControlName="Company_Office_Phone_N" class="form-control"
                                     appPhoneNumberMask [phoneNumberFormat]="'tenDigit'" [attr.maxlength]="fieldMaxLengths.Company_Office_Phone_N"
                                     placeholder="XXX-XXX-XXXX"
                                     appAiHint="New Company Office Phone" [aiHintForm]="icdForm" />
                              <div class="text-right small mt-1"
                                   [ngClass]="{'text-danger': f.Company_Office_Phone_N.errors?.maxlength,'text-muted': !f.Company_Office_Phone_N.errors?.maxlength }">

                                  {{ icdForm.get('Company_Office_Phone_N')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Office_Phone_N }}

                              </div>
                              <div *ngIf="submitted && f.Company_Office_Phone_N.errors" class="invalid-feedback">
                                  <div *ngIf="f.Company_Office_Phone_N.errors.required">Office Phone  is required</div>
                                  <div *ngIf="f.Company_Office_Phone_N.errors.maxlength">
                                      Maximum {{ fieldMaxLengths.Company_Office_Phone_N }} characters allowed
                                  </div>
                              </div>

                          </div>
                      </div>

                  </div>


                  <div class="row">
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="col-form-label  col-md-12" for="login-Owner_Email">Old Email </label>
                              <input type="text" formControlName="Owner_Email" class="form-control"
                                     placeholder="Enter Owner_Email"
                                     appAiHint="Owner Email" [aiHintForm]="icdForm" />
                              <div *ngIf="submitted && f.Owner_Email.errors" class="invalid-feedback">
                                  <div *ngIf="f.Owner_Email.errors.required">Owner_Email  is required</div>
                              </div>

                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="col-form-label  col-md-12" for="login-Owner_Email_N">New Email </label>
                              <input type="text" formControlName="Owner_Email_N" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Email_N"
                                     placeholder="Enter  Email"
                                     appAiHint="New Owner Email" [aiHintForm]="icdForm" />
                              <div class="text-right small mt-1"
                                   [ngClass]="{'text-danger': f.Owner_Email_N.errors?.maxlength,'text-muted': !f.Owner_Email_N.errors?.maxlength}">

                                  {{ icdForm.get('Owner_Email_N')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Email_N }}

                              </div>
                              <div *ngIf="submitted && f.Owner_Email_N.errors" class="invalid-feedback">
                                  <div *ngIf="f.Owner_Email_N.errors.required">New Email  is required</div>
                                  <div *ngIf="f.Owner_Email_N.errors.maxlength">
                                      Maximum {{ fieldMaxLengths.Owner_Email_N }} characters allowed
                                  </div>
                              </div>

                          </div>
                      </div>

                  </div>
                  <div class="row hide">


                      <div class="col-sm-4 ">
                          <div class="form-group">
                              <label class="col-form-label  col-md-12" for="login-Sales_tax_perc">Old Sales Tax </label>
                              <input type="text" formControlName="Sales_tax_perc" class="form-control" [attr.maxlength]="fieldMaxLengths.Sales_tax_perc"
                                     placeholder="Enter  old Sales Tax  " />
                              <div class="text-right small mt-1"
                                   [ngClass]="{'text-danger': f.Sales_tax_perc.errors?.maxlength,'text-muted': !f.Sales_tax_perc.errors?.maxlength}">

                                  {{ icdForm.get('Sales_tax_perc')?.value?.length || 0 }}/{{ fieldMaxLengths.Sales_tax_perc }}

                              </div>
                              <div *ngIf="submitted && f.Sales_tax_perc.errors" class="invalid-feedback">
                                  <div *ngIf="f.Sales_tax_perc.errors.required">Old Sales Tax   is required</div>
                                  <div *ngIf="f.Sales_tax_perc.errors.maxlength">
                                      Maximum {{ fieldMaxLengths.Sales_tax_perc }} characters allowed
                                  </div>
                              </div>

                          </div>
                      </div>

                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="col-form-label  col-md-12" for="login-Sales_tax_perc_N">New Sales Tax </label>
                              <input type="text" formControlName="Sales_tax_perc_N" class="form-control"
                                     placeholder="Enter  New Sales Tax  " />
                              <div *ngIf="submitted && f.Sales_tax_perc_N.errors" class="invalid-feedback">
                                  <div *ngIf="f.Sales_tax_perc_N.errors.required">New Sales Tax   is required</div>
                              </div>

                          </div>
                      </div>
                  </div>







                  <div class="col-sm-12">

                      <div class="form-group">
                          <div class="custom-control custom-switch custom-switch-on-success">
                              <input type="checkbox" formControlName="isNew_DBA_Name" (change)="onChangeisNewDBA()" class="custom-control-input" id="isNew_DBA_Name">
                              <label class="custom-control-label" for="isNew_DBA_Name">Is this a new DBA or Corporation Name? </label>

                          </div>
                      </div>

                  </div>
                  <!--<div class="col-sm-4" *ngIf="isNew_DBA_Name">
      <div class="form-group">
        <label class="col-form-label  col-md-12" for="login-New_DBA_Name">New DBA Name </label>
        <input type="text" formControlName="New_DBA_Name" class="form-control"
               [ngClass]="{'is-valid': f.New_DBA_Name.valid, 'is-invalid' : submitted && !f.New_DBA_Name.valid}" placeholder="Enter New DBA Name"
               appAiHint="New DBA Name" [aiHintForm]="icdForm" />
        <div *ngIf="submitted && f.New_DBA_Name.errors" class="invalid-feedback">
          <div *ngIf="f.New_DBA_Name.errors.required">New DBA Name is required</div>
        </div>

      </div>
    </div>
    <div class="col-sm-4" *ngIf="isNew_DBA_Name">
      <div class="form-group">

        <label class="col-form-label  col-md-12" for="login-DBA_Doc">DBA Document</label>
        <input type="file" multiple formControlName="DBA_Doc" class="form-control" (change)="onFileSelected($event, 'DBA_Doc')"
               [ngClass]="{'is-valid': f.DBA_Doc.valid, 'is-invalid' : submitted && !f.DBA_Doc.valid}" />
        <div *ngIf="submitted && f.DBA_Doc.errors" class="invalid-feedback">
          <div *ngIf="f.DBA_Doc.errors.required">DBA_Doc is required</div>
        </div>

      </div>
    </div>-->


                  <div *ngIf="isNew_DBA_Name">

                      <div *ngFor="let visible of dbaRowsVisibility; let i = index">
                          <div class="row" [style.display]="visible ? 'flex' : 'none'">
                              <div class="col-sm-4">
                                  <div class="form-group">
                                      <label for="New_DBA_Name{{ i }}">New DBA or Corporation Name.</label>
                                      <input type="text"
                                             id="New_DBA_Name{{ i }}"
                                             [formControlName]="'New_DBA_Name' + i"
                                             class="form-control" [attr.maxlength]="fieldMaxLengths['New_DBA_Name' + i]"
                                             placeholder="Enter New DBA or Corporation Name." />
                                      <div class="text-right small mt-1"
                                           [ngClass]="{'text-danger': icdForm.get('New_DBA_Name' + i)?.errors?.maxlength,'text-muted': !icdForm.get('New_DBA_Name' + i)?.errors?.maxlength }">

                                          {{ icdForm.get('New_DBA_Name' + i)?.value?.length || 0 }}/{{ fieldMaxLengths['New_DBA_Name' + i] }}

                                      </div>
                                      <div *ngIf="submitted && icdForm.get('New_DBA_Name' + i)?.errors"
                                           class="invalid-feedback">

                                          <div *ngIf="icdForm.get('New_DBA_Name' + i)?.errors?.maxlength">
                                              Maximum {{ fieldMaxLengths['New_DBA_Name' + i] }} characters allowed
                                          </div>

                                      </div>

                                  </div>
                              </div>

                              <div class="col-sm-4">
                                  <div class="form-group">
                                      <label for="DBA_Doc{{ i }}">Documentation</label>
                                      <input type="file"
                                             id="DBA_Doc{{ i }}" (change)="onFileSelected($event, 'DBA_Doc' + i)"
                                             [formControlName]="'DBA_Doc' + i"
                                             class="form-control" />
                                      <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'DBA_Doc' + i }"></ng-container>
                                  </div>
                                  <div *ngIf="verificationState['DBA_Doc' + i] === 'verifying'" class="mt-1 text-muted small">
                                      <i class="fas fa-spinner fa-spin"></i> Verifying document...
                                  </div>
                                  <div *ngIf="verificationState['DBA_Doc' + i] === 'pass'" class="mt-1 text-success small">
                                      <i class="fas fa-check-circle"></i> Document verified
                                  </div>
                                  <div *ngIf="verificationState['DBA_Doc' + i] === 'warn'" class="mt-1 text-warning small">
                                      <i class="fas fa-exclamation-triangle"></i> Verification warning
                                      <ul class="mb-0 pl-3">
                                          <li *ngFor="let issue of verificationIssues['DBA_Doc' + i]">{{issue}}</li>
                                      </ul>
                                  </div>
                                  <div *ngIf="verificationState['DBA_Doc' + i] === 'warn_disabled_never_shown'" class="mt-1 text-warning small">
                                      <i class="fas fa-exclamation-triangle"></i> Verification failed
                                      <ul class="mb-0 pl-3">
                                          <li *ngFor="let issue of verificationIssues['DBA_Doc' + i]">{{issue}}</li>
                                      </ul>
                                  </div>
                              </div>

                              <div class="col-sm-4 d-flex align-items-center">
                                  <button type="button" class="btn btn-danger" (click)="removeDBARow(i)">Remove</button>
                              </div>
                          </div>
                      </div>
                      <div class="mt-3 pull-right">
                          <button type="button" class="btn btn-primary" (click)="addDBARow()">Add additional DBA or Corp Name</button>

                      </div>
                  </div>
                  <!-- NEW: DBA Preference Questions -->
                  <div class="col-sm-12 mt-4" *ngIf="isNew_DBA_Name">
                      <div class="card card-info">
                          <div class="card-header">
                              <h4 class="card-title">DBA Preference</h4>
                          </div>
                          <div class="card-body">

                              <!-- Question 1: Is this Preferred DBA? -->
                              <div class="form-group">
                                  <label>Is this the ICD's Preferred DBA? <code>*</code></label>
                                  <div class="form-check">
                                      <input type="radio" formControlName="isPreferredDBA" value="Yes"
                                             id="isPreferredDBA_Yes" class="form-check-input"
                                             (change)="onChangePreferredDBA()" />
                                      <label class="form-check-label" for="isPreferredDBA_Yes">
                                          Yes
                                      </label>
                                  </div>
                                  <div class="form-check">
                                      <input type="radio" formControlName="isPreferredDBA" value="No"
                                             id="isPreferredDBA_No" class="form-check-input"
                                             (change)="onChangePreferredDBA()" />
                                      <label class="form-check-label" for="isPreferredDBA_No">
                                          No
                                      </label>
                                  </div>
                                  <div *ngIf="submitted && f.isPreferredDBA.errors" class="invalid-feedback d-block">
                                      <div *ngIf="f.isPreferredDBA.errors.required">Is this the ICD's Preferred DBA is required</div>
                                  </div>
                              </div>

                              <!-- Question 2: Preferred DBA Name (conditional) -->
                              <div class="form-group" *ngIf="f.isPreferredDBA.value === 'No'">
                                  <label class="col-form-label col-md-12" for="login-preferredDBAName">
                                      What is the ICD's preferred DBA Name? <code>*</code>
                                  </label>
                                  <input type="text" formControlName="preferredDBAName"
                                         class="form-control"
                                         [attr.maxlength]="fieldMaxLengths.preferredDBAName"
                                         [ngClass]="{'is-valid': f.preferredDBAName.valid, 'is-invalid' : submitted && !f.preferredDBAName.valid}"
                                         placeholder="Enter preferred DBA name"
                                         appAiHint="Preferred DBA Name" [aiHintForm]="icdForm" />
                                  <div class="text-right small mt-1"
                                       [ngClass]="{'text-danger': f.preferredDBAName.errors?.maxlength,'text-muted': !f.preferredDBAName.errors?.maxlength}">
                                      {{ icdForm.get('preferredDBAName')?.value?.length || 0 }}/{{ fieldMaxLengths.preferredDBAName }}
                                  </div>
                                  <div *ngIf="submitted && f.preferredDBAName.errors" class="invalid-feedback d-block">
                                      <div *ngIf="f.preferredDBAName.errors.required">Preferred DBA Name is required</div>
                                      <div *ngIf="f.preferredDBAName.errors.maxlength">
                                          Maximum {{ fieldMaxLengths.preferredDBAName }} characters allowed
                                      </div>
                                  </div>
                              </div>

                          </div>
                      </div>
                  </div>
                  <!-- END: DBA Preference Questions -->
                  <div class="col-sm-12">

                      <div class="form-group">
                          <div class="custom-control custom-switch  custom-switch-on-success">
                              <input type="checkbox" formControlName="isRemove_DBA_Name" (change)="onChangeisRemoveDBA()" class="custom-control-input" id="isRemove_DBA_Name">
                              <label class="custom-control-label" for="isRemove_DBA_Name">Are you removing a DBA?	</label>

                          </div>
                      </div>

                  </div>
                  <div class="col-sm-4" *ngIf="isRemove_DBA_Name">
                      <div class="form-group">
                          <label class="col-form-label  col-md-12" for="login-Remove_DBA_Name">Remove DBA Name </label>
                          <input type="text" formControlName="Remove_DBA_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Remove_DBA_Name"
                                 [ngClass]="{'is-valid': f.Remove_DBA_Name.valid, 'is-invalid' : submitted && !f.Remove_DBA_Name.valid}" placeholder="Enter  Remove_DBA_Name  "
                                 appAiHint="Remove DBA Name" [aiHintForm]="icdForm" />
                          <div class="text-right small mt-1"
                               [ngClass]="{'text-danger': f.Remove_DBA_Name.errors?.maxlength,'text-muted': !f.Remove_DBA_Name.errors?.maxlength}">

                              {{ icdForm.get('Remove_DBA_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Remove_DBA_Name }}

                          </div>
                          <div *ngIf="submitted && f.Remove_DBA_Name.errors" class="invalid-feedback">
                              <div *ngIf="f.Remove_DBA_Name.errors.required">Remove_DBA_Name  is required</div>
                              <div *ngIf="f.Remove_DBA_Name.errors.maxlength">
                                  Maximum {{ fieldMaxLengths.Remove_DBA_Name }} characters allowed
                              </div>
                          </div>

                      </div>
                  </div>




              </div>

              <!--<div class="form-group pull-right" *ngIf="btnDisplay">
    <button type="button" class="btn btn-primary" (click)="saveSection1()">Save Info</button>
  </div>-->

            </div>

        </div>


         

      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>
        <div class="mb-3" *ngIf="btnDisplay">


          <button type="submit" class="btn btn-success float-right">
            {{isLoading ? 'Submit' : 'Submit'}}

          </button>


        </div>
  </form>
</div>


